// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10 9H6V11H10V9ZM18 9H14V11H18V9ZM12 13.5858L11 12.5858L9.58579 14L10.5858 15L9.58579 16L11 17.4142L12 16.4142L13 17.4142L14.4142 16L13.4142 15L14.4142 14L13 12.5858L12 13.5858Z"}}]};

const ShutupFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shutup-filled',
    ref,
    icon: element,
  },
));

ShutupFilledIcon.displayName = 'ShutupFilledIcon';

export default ShutupFilledIcon;
